import {
  link_default
} from "./chunk-6WQWOYMP.js";
import {
  label_default
} from "./chunk-AWEODRKT.js";

// src/blocks/date-tile/date-tile.tsx
import { format } from "date-fns";
import { jsx, jsxs } from "react/jsx-runtime";
var DateTile = ({
  availability = "U",
  availabilityQty = "S",
  className = "",
  id,
  labels = {
    flagFewSeatsLeft: "Few Seats Left",
    flagSoldOut: "Sold Out",
    flagUnavailable: "Sold Out"
  },
  startDate = ""
}) => {
  const shouldRender = startDate;
  if (!shouldRender) return null;
  const targetPerformanceSeatMap = `/order/${id}/seat-map`;
  const isAvailable = availability !== "U" && availabilityQty !== "U";
  const isLowAvailability = availabilityQty === "L";
  const isSoldOut = availabilityQty === "S";
  const isUnavailable = availabilityQty === "U";
  const isDisabled = isSoldOut || !isAvailable;
  const label = isSoldOut ? labels?.flagSoldOut : isLowAvailability ? labels?.flagFewSeatsLeft : isUnavailable ? labels?.flagUnavailable : "";
  return /* @__PURE__ */ jsxs(
    link_default,
    {
      className: `${className} relative border-1 rounded-sm border-primary h-26.5 lg:h-32 w-[var(--datetile-width-mobile)] lg:w-[var(--datetile-width)]`,
      "data-performance-id": id,
      disabled: isDisabled,
      href: targetPerformanceSeatMap,
      id,
      tracking: {
        component: "Date Tile",
        label: targetPerformanceSeatMap.toString()
      },
      children: [
        label && /* @__PURE__ */ jsx(
          label_default,
          {
            text: label,
            className: "label-notification-default absolute left-[50%] translate-x-[-50%] translate-y-[-50%] whitespace-nowrap"
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: `flex flex-col items-center justify-start ${isDisabled ? "opacity-32" : ""}`,
            children: [
              /* @__PURE__ */ jsx("span", { className: "heading-md mt-6 mb-1 lg:mt-8 ", children: format(startDate, "MMM d") }),
              /* @__PURE__ */ jsx("span", { className: "body-xs", children: format(startDate, "EEE, h:mm a") })
            ]
          }
        )
      ]
    }
  );
};
var date_tile_default = DateTile;

export {
  date_tile_default
};
